import SalesLayOut from "views/Sales-Sections/SalesLayOut";
import SalesReturn from "views/Sales-Sections/salesReturn/SalesReturn";
import SalesReturnB2C from "views/Sales-Sections/SalesRetrunB2C/SalesRetrunB2C";
import SalesPos from "views/Sales-Sections/salesPos/SalesPos";
import SalesPosB2C from "views/Sales-Sections/salesPosB2C/SalesPosB2C";
import OrderForm from "views/Sales-Sections/orderForm/OrderForm";

const SalesRoute = {
  path: "sales",
  element: <SalesLayOut />,
  ref: "inventory-sales",
  children: [
    {
      path: "salesPos",
      ref: "inventory-sales-b2b",
      element: <SalesPos typp="salesBill" />,
    },
    {
      path: "salesPosb2c",
      ref: "inventory-sales-b2c",
      element: <SalesPosB2C />,
    },
    {
      path: "salesReturn",
      ref: "inventory-sales-return",
      element: <SalesReturn typp="salesReturn" />,
    },
    {
      path: "salesReturnB2C",
      ref: "inventory-sales-return-b2c",
      element: <SalesReturnB2C typp="salesReturnB2C" />,
    },
    {
      path: "orderForm",
      ref: "inventory-sales-order-form",
      element: <OrderForm typp="orderForm" />,
    },
  ],
};
export default SalesRoute;
